<template>
  <b-card>
    <b-skeleton-wrapper
      :loading="renderLoading"
      class="animate__animated animate__fadeIn"
    >
      <template #loading>
        <div class="content-header-card">
          <div class="content-header-img">
            <b-skeleton-img
              width="40px"
              height="40px"
              class="tee-load"
            />
          </div>
          <div class="content-header-name w-50">
            <b-skeleton
              width="100%"
              class="skeleton-header"
            />
          </div>
        </div>
        <div class="content-body-card mt-1">
          <div class="d-flex justify-content-center flex-column">
            <b-skeleton width="70%" />
            <b-skeleton width="90%" />
            <b-skeleton width="50%" />
          </div>
        </div>
      </template>

      <div v-if="noItem">
        <card-no-item
          :height="100"
          :text-no-img="'ไม่มีข้อมูล'"
        />
      </div>
      <div
        v-else
        class="animate__animated animate__fadeIn"
      >
        <div class="content-header-card">
          <div class="content-header-img">
            <img
              class="w-100"
              :src="$props.configCard.logo"
              alt=""
              draggable="false"
            >
          </div>
          <div class="content-header-name">
            <div>{{ $props.configCard.name }}</div>
          </div>
        </div>
        <div class="content-body-card">
          <div class="overall-value">
            {{ formatter.format(renderData) }}
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BSkeletonWrapper,
  BSkeleton,
  BSkeletonImg,
} from 'bootstrap-vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

import { computed, onBeforeMount, ref } from '@vue/composition-api'
import { formatter } from '@/utils/scripts/format-currency'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BSkeletonWrapper,
    BSkeleton,
    BSkeletonImg,
    CardNoItem,
    vSelect,
  },
  props: {
    configCard: Object,
    dataBi: { type: Array, default: [] },
  },
  setup(props) {
    const dataCard = ref([])
    const isLoading = ref(false)
    const noItem = ref(false)

    const renderData = computed(
      () => props.dataBi.find(o => o.id == props.configCard.id)?.data.value,
    )

    const renderLoading = computed(() => props.dataBi.length == 0)

    return {
      dataCard,
      isLoading,
      noItem,
      formatter,
      renderData,
      renderLoading,
    }
  },
}
</script>
